module.exports = __webpack_public_path__ + "img/cc.985a76c5.svg";